export const getYear = state => state.reportCarrierUsage.getIn(['list', 'year'])
export const getData = state => state.reportCarrierUsage.getIn(['list', 'data'])
export const getFetching = state => state.reportCarrierUsage.getIn(['list', 'fetching'])
export const getError = state => state.reportCarrierUsage.getIn(['list', 'error'])
